import { Description, HeadingContent, Wrapper } from '../Banners.styles';

export default function WIPReservable() {
  return (
    <Wrapper>
      <HeadingContent>Vehicle is almost ready</HeadingContent>
      <Description>
        Sign up for alerts when we have more photos and details for this
        vehicle. Pre-order to get first dibs when it’s available for purchase.
      </Description>
    </Wrapper>
  );
}
